import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import React, { useEffect, useRef } from "react";
import FormTextField from "../../components/formFields/FormTextField";
import {
  phoneValidator,
  requiredValidator,
} from "../../components/formFields/CommonValidator";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { Button } from "@progress/kendo-react-buttons";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { closed } from "../../components/drawer/drawerSlice";
import { LoadingPanel } from "../../components/layout/Loading";
import { Typography } from "@progress/kendo-react-common";
import { RxCross1 } from "react-icons/rx";
import { BALANCE_TYPE, ENTRY_TYPE } from "../../_contstants/common";
import moment from "moment";
import {
  createWalletReturn,
  getAllWalletReturns,
  getWalletDetailFromMobileNo,
} from "./services/walletamountreturn.services";
import {
  clearWalletAmountReturnDetails,
  clearWalletAmountReturnID,
} from "./walletamountreturnSlice";
import FormNumericTextField from "../../components/formFields/FormNumericTextField";
import FormDatePicker from "../../components/formFields/FormDateField";
import FormTextArea from "../../components/formFields/FormTextArea";
import { formatIndianNumber } from "../../_helper/helper";

const CreateWalletAmountReturn: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);

  const WalletAmountReturnDetail = useAppSelector(
    (state) => state.walletamountreturn.WalletAmountReturnDetail
  );
  const formLoading = useAppSelector(
    (state) => state.walletamountreturn.formLoading
  );
  const FilterWalletAmountReturn = useAppSelector(
    (state) => state.walletamountreturn.FilterWalletAmountReturn
  );
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);

  useEffect(() => {
    return () => {
      dispatch(clearWalletAmountReturnDetails());
      dispatch(clearWalletAmountReturnID());
      dispatch(closed());
    };
  }, []);

  const handleGetWalletDetails = async (
    mobileno: string,
    formRenderProps: FormRenderProps
  ) => {
    if (mobileno) {
      const response = await dispatch(getWalletDetailFromMobileNo(mobileno));
      formRenderProps.onChange("WalletDetails", { value: response.payload });
    }
  };

  const handleSubmit = async (values: any) => {
    console.log("called")
    try {
      const payload = {
        UserID: values?.WalletDetails?.id,
        ReturnBalanceType: values?.ReturnBalanceType,
        EntryType: values?.EntryType,
        Amount: values?.Amount ? +values?.Amount : 0,
        ReturnDate: values?.ReturnDate
          ? moment(values?.ReturnDate).format("YYYY-MM-DD")
          : "",
        Remarks: values?.Remarks,
      };
      const response = await dispatch(createWalletReturn(payload));
      if (response?.meta?.requestStatus === "fulfilled") {
        dispatch(closed());
        dispatch(clearWalletAmountReturnDetails());
        const payload = {
          ...FilterWalletAmountReturn,
          Limit: +pageLimit,
          Skip: +currentPage * +pageLimit,
        };
        dispatch(getAllWalletReturns(payload));
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  const handleFormClose = () => {
    dispatch(closed());
  };

  return (
    <>
      {formLoading && <LoadingPanel gridRef={gridRef} />}
      <Form
        onSubmit={handleSubmit}
        initialValues={WalletAmountReturnDetail}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement style={{ width: "100%" }}>
            <GridLayout
              style={{
                marginRight: 10,
              }}
              gap={{ rows: 10, cols: 10 }}
              cols={[{ width: "50%" }, { width: "50%" }]}
            >
              <GridLayoutItem className="master-drawer-header" colSpan={2}>
                <Typography.h4 className="m-0">
                  {"Create Wallet Amount Add / Return"}
                </Typography.h4>
                <Button
                  type="button"
                  fillMode={"flat"}
                  themeColor={"dark"}
                  style={{ marginRight: 4 }}
                  onClick={() => dispatch(closed())}
                >
                  <RxCross1 />
                </Button>
              </GridLayoutItem>
              <GridLayoutItem
                colSpan={2}
                className="d-flex gap-3 align-items-start"
              >
                <Field
                  name="MobileNo"
                  type="number"
                  max="10"
                  wrapperClassName="w-50"
                  placeholder=" i.e 9999999999"
                  label="Mobile No"
                  astrike={true}
                  validator={phoneValidator}
                  component={FormTextField}
                />
                <Button
                  type="submit"
                  fillMode={"solid"}
                  themeColor={"primary"}
                  style={{ marginTop: 34 }}
                  onClick={() =>
                    handleGetWalletDetails(
                      formRenderProps.valueGetter("MobileNo"),
                      formRenderProps
                    )
                  }
                  disabled={formLoading}
                >
                  View
                </Button>
              </GridLayoutItem>
              {formRenderProps.valueGetter("WalletDetails") && (
                <>
                  <GridLayoutItem
                    colSpan={2}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      marginTop: 10,
                      background: "gainsboro",
                      borderRadius: "4px",
                      padding: "8px",
                    }}
                  >
                    <div>
                      <Typography.h5>
                        Name :{" "}
                        {
                          formRenderProps.valueGetter("WalletDetails")
                            ?.first_name
                        }{" "}
                        {
                          formRenderProps.valueGetter("WalletDetails")
                            ?.last_name
                        }
                      </Typography.h5>
                    </div>
                    <div className="d-flex gap-5">
                      <Typography.h6 style={{ fontSize: 16 }}>
                        Wallet Balance :{" "}
                      </Typography.h6>
                      <div className="d-flex flex-column">
                        <strong style={{ fontSize: 16, fontWeight: 700 }}>
                          ₹{" "}
                          {formatIndianNumber(
                            formRenderProps.valueGetter("WalletDetails")
                              ?.refundable_walletamount || 0
                          )}
                        </strong>
                        <span style={{ fontSize: 12 }}>Refundable</span>
                      </div>
                      <div className="d-flex flex-column">
                        <strong style={{ fontSize: 16, fontWeight: 700 }}>
                          ₹{" "}
                          {formatIndianNumber(
                            formRenderProps.valueGetter("WalletDetails")
                              ?.non_refundable_walletamount || 0
                          )}
                        </strong>
                        <span style={{ fontSize: 12 }}>Non Refundable</span>
                      </div>
                      <div className="d-flex flex-column">
                        <strong style={{ fontSize: 16, fontWeight: 700 }}>
                          ₹{" "}
                          {formatIndianNumber(
                            formRenderProps.valueGetter("WalletDetails")
                              ?.wallet_balance || 0
                          )}
                        </strong>
                        <span style={{ fontSize: 12 }}>Total</span>
                      </div>
                    </div>
                  </GridLayoutItem>
                  <GridLayoutItem colSpan={1}>
                    <Field
                      name={"EntryType"}
                      label={"Entry Type"}
                      component={FormSelectionField}
                      placeholder="Entry Type"
                      astrike={true}
                      validator={requiredValidator}
                      onChange={(e) => {
                        if (e?.value === "Return") {
                          if (
                            formRenderProps.valueGetter("ReturnBalanceType") ===
                              "Refundable" &&
                            formRenderProps.valueGetter("Amount") >
                              formRenderProps.valueGetter("WalletDetails")
                                ?.refundable_walletamount
                          ) {
                            formRenderProps.onChange("Amount", { value: 0 });
                          } else if (
                            formRenderProps.valueGetter("ReturnBalanceType") ===
                              "Non Refundable" &&
                            formRenderProps.valueGetter("Amount") >
                              formRenderProps.valueGetter("WalletDetails")
                                ?.non_refundable_walletamount
                          ) {
                            formRenderProps.onChange("Amount", { value: 0 });
                          }
                        }
                      }}
                      options={ENTRY_TYPE.map((type: any) => {
                        return {
                          value: type.value,
                          label: type.label,
                        };
                      })}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem colSpan={1}>
                    <Field
                      name={"ReturnBalanceType"}
                      label={"Balance Type"}
                      component={FormSelectionField}
                      placeholder="Balance Type"
                      astrike={true}
                      validator={requiredValidator}
                      onChange={(e) => {
                        if (
                          formRenderProps.valueGetter("EntryType") === "Return"
                        ) {
                          if (
                            e?.value === "Refundable" &&
                            formRenderProps.valueGetter("Amount") >
                              formRenderProps.valueGetter("WalletDetails")
                                ?.refundable_walletamount
                          ) {
                            formRenderProps.onChange("Amount", { value: 0 });
                          } else if (
                            e?.value === "Non Refundable" &&
                            formRenderProps.valueGetter("Amount") >
                              formRenderProps.valueGetter("WalletDetails")
                                ?.non_refundable_walletamount
                          ) {
                            formRenderProps.onChange("Amount", { value: 0 });
                          }
                        }
                      }}
                      options={BALANCE_TYPE.map((type: any) => {
                        return {
                          value: type.value,
                          label: type.label,
                        };
                      })}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem colSpan={1}>
                    <Field
                      name="Amount"
                      label="Amount"
                      component={FormNumericTextField}
                      placeholder="Amount"
                      astrike={true}
                      max={
                        formRenderProps.valueGetter("EntryType") === "Return"
                          ? formRenderProps.valueGetter("ReturnBalanceType") ===
                            "Refundable"
                            ? formRenderProps.valueGetter("WalletDetails")
                                ?.refundable_walletamount || 0
                            : formRenderProps.valueGetter("WalletDetails")
                                ?.non_refundable_walletamount || 0
                          : undefined
                      }
                      validator={requiredValidator}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem colSpan={1}>
                    <Field
                      name="ReturnDate"
                      label="Date"
                      format="dd/MM/yyyy"
                      component={FormDatePicker}
                      astrike={true}
                      validator={requiredValidator}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem colSpan={2}>
                    <Field
                      name="Remarks"
                      label="Remarks"
                      component={FormTextArea}
                      rows={4}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem
                    colSpan={2}
                    style={{
                      textAlign: "end",
                      marginTop: "10px",
                      width: "100%",
                    }}
                  >
                    <Button
                      type="button"
                      fillMode={"outline"}
                      themeColor={"primary"}
                      style={{ marginRight: 4 }}
                      onClick={handleFormClose}
                    >
                      Cancel
                    </Button>
                    <ButtonWithLoading
                      label={"Create"}
                      type="submit"
                      disabled={!formRenderProps.allowSubmit || formLoading}
                      loading={formLoading}
                    />
                  </GridLayoutItem>
                </>
              )}
            </GridLayout>
          </FormElement>
        )}
      />
    </>
  );
};

export default CreateWalletAmountReturn;
